module.exports = __webpack_public_path__ + "static/media/p003.7b7278a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/p003.jpg
// module id = 1516
// module chunks = 0